import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const logoPath = "/240822-Flateroo-Logo-white-rgb.svg";

  return (
    <div className="p-3 md:p-5">
      <footer className="bg-[#6649ff] text-white px-6 md:px-12 py-8 md:py-10 rounded-2xl md:rounded-3xl">
        <div className="flex flex-col gap-8">
          {/* Logo + tagline */}
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
            <img
              src={logoPath}
              alt="Flateroo logo"
              className="h-6 md:h-7 w-auto"
            />
            <p className="text-sm font-gnarly-regular text-white/60">
              {t("by_students_for_students")}
            </p>
          </div>

          {/* Divider */}
          <div className="h-px w-full bg-white/15" />

          {/* Links + copyright */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm font-gnarly-regular text-white/60">
              <a
                href="/about"
                className="hover:text-white transition-colors duration-200"
              >
                {t("about_link")}
              </a>
              <a
                href="/faq"
                className="hover:text-white transition-colors duration-200"
              >
                {t("faq_link")}
              </a>
              <a
                href="/impressum"
                className="hover:text-white transition-colors duration-200"
              >
                {t("impressum_link")}
              </a>
              <a
                href="/support"
                className="hover:text-white transition-colors duration-200"
              >
                {t("contact")}
              </a>
            </div>
            <p className="text-sm font-gnarly-regular text-white/40">
              &copy; {new Date().getFullYear()} Flateroo
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
